import { ApplicationMainMenuOutputWithStatus } from './application-main-menu-output-with-status.model';


export class SelectByMainMenuIdOutput implements ISelectByMainMenuIdOutput {
    status!: number;
    message!: string;
    data!: ApplicationMainMenuOutputWithStatus;

    constructor(data?: ISelectByMainMenuIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ApplicationMainMenuOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectByMainMenuIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectByMainMenuIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISelectByMainMenuIdOutput {
    status: number;
    message: string;
    data: ApplicationMainMenuOutputWithStatus;
}

